export const LABELS = {
  CONNECT_LABEL: "Connect",
  BORROWING_POWER_USED: "Borrowing Power Used",
  BORROWING_POWER_VALUE: "Borrowing Power",
  BORROWED_VALUE: "You borrowed",
  GIVE_SOL: "Give me SOL",
  LIQUIDATION_INFO:
    "This view displays all loans that can be liquidated. A liquidation is a process where borrower collateral does not cover value of the loan. It is represented by health factor falling below 1.0. When a loan is liquidated, an liquidator can purchase collateral at a discount by repaing the portio of the loan. ",
  FAUCET_INFO:
    "- Click to fund your Solana wallet with 2 SOL in dev network. (devnet)",
  ACCOUNT_FUNDED: "Account funded.",
  AIRDROP_FAIL: "Airdrop failed, limit reached.",
  REPAY_QUESTION: "How much would you like to repay?",
  REPAY_ACTION: "Repay",
  RESERVE_STATUS_TITLE: "Reserve Status & Configuration",
  AUDIT_WARNING:
    "Oyster is an unaudited software project used for internal purposes at the Solana Foundation. This app is not for public use.",
  FOOTER:
    'This page was produced by the Solana Foundation ("SF") for internal educational and inspiration purposes only. SF does not encourage, induce or sanction the deployment, integration or use of Oyster or any similar application (including its code) in violation of applicable laws or regulations and hereby prohibits any such deployment, integration or use. Anyone using this code or a derivation thereof must comply with applicable laws and regulations when releasing related software.',
  MENU_HOME: "Home",
  MENU_DASHBOARD: "Dashboard",
  DASHBOARD_INFO: "Connect to a wallet to view your deposits/loans.",
  TRANSACTIONS_INFO: "Connect to a wallet to view your transactions.",
  NO_LOANS_NO_DEPOSITS: "No loans or deposits.",
  MENU_DEPOSIT: "Deposit",
  DEPOSITS: "Deposits",
  BORROWS: "Borrows",
  LOAN_TO_VALUE: "Loan to value",
  MENU_BORROW: "Borrow",
  MENU_LIQUIDATE: "Liquidate",
  MENU_FAUCET: "Faucet",
  MENU_TRANSACTION: "Transactions",
  MARGIN_TRADING: "Margin Trading",
  APP_TITLE: "Million Finance",
  CONNECT_BUTTON: "Connect",
  WALLET_TOOLTIP: "Wallet public key",
  WALLET_BALANCE: "Wallet balance",
  SETTINGS_TOOLTIP: "Settings",
  SELECT_COLLATERAL: "Select collateral",
  COLLATERAL: "Collateral",
  BORROW_QUESTION: "How much would you like to borrow?",
  BORROW_ACTION: "Borrow",
  NO_COLLATERAL: "No collateral",
  NO_DEPOSITS: "No deposits",
  NO_LOANS: "No loans",
  NOTHING_BORROWED: "Nothing borrowed yet",
  NOTHING_BORROWED_MESSAGE:
    "There will be a list of all the assets you have borrowed. For now, it's empty since you have not borrowed.",
  BORROW_NOW: "Borrow now",
  LIQUIDATE_QUESTION: "How much would you like to liquidate?",
  LIQUIDATE_ACTION: "Liquidate",
  LIQUIDATE_NO_LOANS: "There are no loans to liquidate.",
  TABLE_TITLE_ASSET: "Asset",
  TABLE_TITLE_YOUR_LOAN_BALANCE: "Loan balance",
  TABLE_TITLE_LOAN_BALANCE: "Loan balance",
  TABLE_TITLE_COLLATERAL_BALANCE: "Collateral",
  TABLE_TITLE_DEPOSIT_BALANCE: "Your deposits",
  TABLE_TITLE_APY: "APY",
  TABLE_TITLE_LTV: "LTV",
  TABLE_TITLE_HEALTH: "Health Factor",
  TABLE_TITLE_BORROW_APY: "Borrow APY",
  TABLE_TITLE_DEPOSIT_APY: "Deposit APY",
  TABLE_TITLE_TOTAL_BORROWED: "Total Borrowed",
  TABLE_TITLE_MARKET_SIZE: "Market Size",
  TABLE_TITLE_ACTION: "Action",
  TABLE_TITLE_DEPOSITS: "Deposits",
  TABLE_TITLE_WITHDRAWS: "Withdraws",
  TABLE_TITLE_BORROWS: "Borrows",
  TABLE_TITLE_REPAY_OBLIGATIONS: "Repay Obligations",
  TABLE_TITLE_LIQUIDATE_OBLIGATIONS: "Liquidate Obligations",
  MAX_LTV: "Maximum LTV",
  LIQUIDATION_THRESHOLD: "Liquidation threshold",
  LIQUIDATION_PENALTY: "Liquidation penalty",
  TABLE_TITLE_MAX_BORROW: "Available for you",
  DASHBOARD_TITLE_LOANS: "Loans",
  DASHBOARD_TITLE_DEPOSITS: "Deposits",
  DEPOSIT_QUESTION: "How much would you like to deposit?",
  WITHDRAW_ACTION: "Withdraw",
  WITHDRAW_QUESTION: "How much would you like to withdraw?",
  DASHBOARD_ACTION: "Go to dashboard",
  GO_BACK_ACTION: "Go back",
  DEPOSIT_ACTION: "Deposit",
  TOTAL_TITLE: "Total",
  TRADING_TABLE_TITLE_MY_COLLATERAL: "Chosen Collateral",
  TRADING_TABLE_TITLE_DESIRED_ASSET: "Desired Asset",
  TRADING_TABLE_TITLE_MULTIPLIER: "Leverage",
  TRADING_TABLE_TITLE_ASSET_PRICE: "Asset Price",
  TRADING_TABLE_TITLE_LIQUIDATION_PRICE: "Liquidation Price",
  TRADING_TABLE_TITLE_APY: "APY",
  TRADING_TABLE_TITLE_ACTIONS: "Action",
  TRADING_ADD_POSITION: "Add Position",
  MARGIN_TRADE_ACTION: "Margin Trade",
  MARGIN_TRADE_CHOOSE_COLLATERAL_AND_LEVERAGE:
    "Please choose your collateral and leverage.",
  MARGIN_TRADE_QUESTION:
    "Please choose how much of this asset you wish to purchase.",
  TABLE_TITLE_BUYING_POWER: "Total Buying Power",
  NOT_ENOUGH_MARGIN_MESSAGE:
    "Not enough buying power in oyster to make this trade at this leverage.",
  SET_MORE_MARGIN_MESSAGE:
    "You need more margin to match this leverage amount to make this trade.",
  LEVERAGE_LIMIT_MESSAGE: "You will need more margin to make this trade.",
  NO_DEPOSIT_MESSAGE:
    "You need to deposit coin of this type into oyster before trading with it on margin.",
  NO_COLL_TYPE_MESSAGE: "Choose Collateral CCY",
  SAFER: "Safer",
  RISKIER: "Riskier",
  DEST_PUBKEY: "FV1dZBk1JpUHxZWjAsyxQhD3wnHgieMivYs3gtyAhezy",
  GIF_FEE_PUBKEY: "7ALfysGXbPWsj3Zg7aRtCepVDuqF9PtViS5hkAPv91hq",
};
